import { NgModule } from '@angular/core';
import { RouterModule, Routes, mapToCanActivate } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { RoleGuardService } from '~app/core/auth/services/role-guard.service';
import { CanDeactivateGuard } from '~app/core/core.module';
import { LicensesComponent } from '../licenses/licenses.component';
import { ApplicationEditPageComponent } from './application-edit/application-edit-page.component';
import { ApplicationEmailTemplatesComponent } from './application-email-templates/application-email-templates.component';
import { ApplicationUsersComponent } from './application-users/application-users.component';
import { ApplicationsComponent } from './applications.component';
import { MetadataDefinitionTabComponent } from './metadata-definition-tab/metadata-definition-tab.component';
import { MetadataSetsComponent } from './metadata-set-tab/metadata-set-tab.component';
import { VersionsComponent } from './versions/versions.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import('./application-details/application-details.component').then(
            m => m.ApplicationDetailsComponent
          ),
        children: [
          {
            path: 'edit',
            component: ApplicationEditPageComponent
          },
          {
            path: 'email',
            component: ApplicationEmailTemplatesComponent,
            canDeactivate: [CanDeactivateGuard],
            canActivate: mapToCanActivate([AuthGuard, RoleGuardService]),
            data: {
              expectedRoles: ['Manager', 'Administrator', 'SuperUser']
            }
          },
          {
            path: 'users',
            component: ApplicationUsersComponent
          },
          {
            path: 'versions',
            component: VersionsComponent,
            canActivate: mapToCanActivate([AuthGuard, RoleGuardService]),
            data: {
              expectedRoles: ['Developer', 'Administrator', 'SuperUser']
            }
          },
          {
            path: 'metadata',
            component: MetadataDefinitionTabComponent,
            canDeactivate: [CanDeactivateGuard],
            canActivate: mapToCanActivate([AuthGuard, RoleGuardService]),
            data: {
              expectedRoles: ['Developer', 'Administrator', 'SuperUser']
            }
          },
          {
            path: 'metadatasets',
            component: MetadataSetsComponent,
            canDeactivate: [CanDeactivateGuard],
            canActivate: mapToCanActivate([AuthGuard, RoleGuardService]),
            data: {
              expectedRoles: ['Developer', 'Administrator', 'SuperUser']
            }
          },
          {
            path: 'licenses',
            component: LicensesComponent,
            canActivate: mapToCanActivate([AuthGuard, RoleGuardService]),
            data: {
              expectedRoles: ['Manager', 'Administrator', 'SuperUser']
            }
          },
          {
            path: '',
            redirectTo: 'edit',
            pathMatch: 'full'
          }
        ],
        canDeactivate: [CanDeactivateGuard],
        canActivate: mapToCanActivate([AuthGuard, RoleGuardService]),
        data: {
          expectedRoles: ['Developer', 'Manager', 'Administrator', 'SuperUser']
        }
      },
      {
        path: '',
        component: ApplicationsComponent,
        canActivate: mapToCanActivate([AuthGuard, RoleGuardService]),
        data: {
          expectedRoles: ['Developer', 'Manager', 'Administrator', 'SuperUser']
        }
      }
    ]
  },
  {
    path: 'addapplication',
    component: ApplicationEditPageComponent,
    canActivate: mapToCanActivate([AuthGuard, RoleGuardService]),
    data: {
      expectedRoles: ['Manager', 'Administrator', 'SuperUser'],
      addApplication: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApplicationsRoutingModule {}
